// import "./wdyr";
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { DataLayer } from "./DataLayer";
import reducer, { initialState } from "./reducer";
import { BrowserRouter } from "react-router-dom";
// import { createBrowserHistory } from "history";

// const history = createBrowserHistory();

ReactDOM.render(
	<BrowserRouter>
		<React.StrictMode>
			<DataLayer initialState={initialState} reducer={reducer}>
				<App />
			</DataLayer>
		</React.StrictMode>
	</BrowserRouter>,
	document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
